// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + {"538":"recorder","983":"profiler"}[chunkId] + "." + {"538":"7295b88996b1a42c","983":"e3b033da91048763"}[chunkId] + ".js";
};